module.exports = __webpack_public_path__ + "static/media/info-invalid.9cf7714e.svg";